export const updateGestureLock = (
  wasLocked: boolean,
  numberOfTouches: number,
) => {
  'worklet';
  if (numberOfTouches >= 2) {
    return true;
  }
  if (numberOfTouches === 0) {
    return false;
  }
  return wasLocked;
};

export const shouldRejectSingleFingerGesture = (
  isLocked: boolean,
  numberOfTouches: number,
) => {
  'worklet';
  return isLocked || numberOfTouches >= 2;
};

export const shouldApplyPinchUpdate = (
  numberOfPointers: number,
  numberOfTouches: number,
) => {
  'worklet';
  return numberOfPointers >= 2 && numberOfTouches >= 2;
};

export const shouldSettlePinch = (numberOfPointers: number) => {
  'worklet';
  return numberOfPointers === 0;
};

export const PAN_MOMENTUM_MAX_DURATION_MS = 300;

export const shouldApplyPanMomentum = (panDurationMs: number) => {
  'worklet';
  return panDurationMs <= PAN_MOMENTUM_MAX_DURATION_MS;
};

export const shouldAcceptSingleTap = (
  isLocked: boolean,
  wasPanStarted: boolean,
) => {
  'worklet';
  return !isLocked && !wasPanStarted;
};

export const shouldAcceptDoubleTap = (
  isLocked: boolean,
  wasPanStarted: boolean,
) => {
  'worklet';
  return !isLocked && !wasPanStarted;
};

export const didReturnToMinimumScale = (
  reachedZoomedScale: boolean,
  scale: number,
  minScale = 1,
) => {
  'worklet';
  return reachedZoomedScale && scale <= minScale + 0.01;
};
